export default __webpack_public_path__ + "static/media/banner_header_nomina.34a78ec5.jpg";